import { render, staticRenderFns } from "./ItemMobile.vue?vue&type=template&id=5137f954"
import script from "./ItemMobile.vue?vue&type=script&lang=js"
export * from "./ItemMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports